import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Mix } from "Utils/Reflection";

export class MiniMusicGameHolly extends HLF.Input.Receptacle {

    // protected receptacle = this.addChild();
    public z: number = 0;

    protected spine: PIXI.spine.Spine;

    constructor() {
        super();
        this.spine = this._visuals.addChild(HLF.PixiUtils.makeSpine("Holly Front Rig"));
        this.playAnimation("Idle", true);
        // this.spine.position.y = -80;
        // this.isActive = true;
        this.hitArea = new PIXI.RoundedRectangle(-200, -this.height - 10, 420, this.height, 100); // eyeballed
        // const g = this.addChild(new PIXI.Graphics());
        // g.beginFill(0xff0000, 0.5);
        // g.drawShape(this.hitArea as PIXI.RoundedRectangle);
        // g.endFill();

        this.spine.state.addListener({
            complete: this.onAnimComplete.bind(this),
        });
    }

    public onLayout() {
        // preserve aspect ratio
        this.scale.set(Math.max(this.scale.x, this.scale.y));
    }

    public update(pDeltaTime: number) {
        this.spine.update(pDeltaTime);
    }

    public playAnimation(pName: string, pLoop: boolean = true) {
        if (this.spine.state.hasAnimation(pName + "-stepped")) {
            this.spine.state.setAnimation(0, pName + "-stepped", pLoop);
        }
        else if (this.spine.state.hasAnimation(pName)) {
            this.spine.state.setAnimation(0, pName, pLoop);
        }
        else {
            console.error(this.name + " no such animation: " + pName + " or " + pName + "-stepped");
        }
    }

    protected addDraggable(pDraggable: HLF.Input.Draggable) {
        super.addDraggable(pDraggable);
        PubSub.publishSync('drop', pDraggable);
    }

    protected onPointerMove(pEvent: PIXI.InteractionEvent): void {
        super.onTouchMove(pEvent); // sic
    }

    private onAnimComplete(pTrack: PIXI.spine.core.TrackEntry): void {
        if (pTrack.trackIndex === 0) {
            // switch (pTrack.animation.name) {
            //     case ANIM_IDLE_TO_READY:
            //         this.playAnimation(ANIM_READY, false);
            //         break;
            //     case ANIM_READY:
            //         this.playAnimation(ANIM_PLAYING, true);
            //         break;
            // }
        }
    }
}